// eslint-disable-next-line boundaries/no-unknown-files

// тут описываем тип то что приходит с бека в сыром виде
const alertsResourceDtoType = {

};

export default alertsResourceDtoType;
